import React from "react";

// Components
import Layout from "../components/_refactored/Layout";
import GetStarted from "../components/GetStarted";
import SEO from "../components/SEO";

// HOCs
import withLazy from "../hocs/WithLazy";

// Styles
import "../styles/tnc-policy.scss";

// Lazy Load
const InitialTnc = withLazy(() => import("../partials/tnc/InitialTnc"));
const AttachmentA = withLazy(() => import("../partials/tnc/AttachmentA"));
const ScheduleA = withLazy(() => import("../partials/tnc/ScheduleA"));
const ScheduleB = withLazy(() => import("../partials/tnc/ScheduleB"));
const ScheduleC = withLazy(() => import("../partials/tnc/ScheduleC"));
const ScheduleD = withLazy(() => import("../partials/tnc/ScheduleD"));
const ScheduleE = withLazy(() => import("../partials/tnc/ScheduleE"));
const ScheduleF = withLazy(() => import("../partials/tnc/ScheduleF"));
const ScheduleG = withLazy(() => import("../partials/tnc/ScheduleG"));
const ScheduleH = withLazy(() => import("../partials/tnc/ScheduleH"));
const ScheduleI = withLazy(() => import("../partials/tnc/ScheduleI"));
// const ScheduleJ = withLazy(() => import("../partials/tnc/ScheduleJ"));

const tnc = () => {
  return (
    <Layout lightHeader>
      <SEO
        title="Terms and Conditions - Cashfree Payments"
        description="Payment Gateway India: Accept and Disburse Payments instantly with Cashfree's Payment Gateway & Payouts. We support Netbanking, Credit / Debit Cards, UPI, Wallets, International Cards & EMI"
        url="https://www.cashfree.com/tnc/"
      />
      <section>
        <section className="bg-cf-dark bg-no-repeat bg-cover pt-[111px] pb-[50px] md:pt-[150px] md:pb-[90px] before:absolute before:bg-triangle before:bg-no-repeat before:top-[200px] md:before:top-[60px] before:left-0 before:w-[110px] before:h-[415px] before:-scale-x-100 before:bg-left after:absolute after:bg-triangle after:bg-no-repeat after:top-[-78px] md:after:top-[-50px] after:right-[-17px] md:after:right-0 after:w-[100px] after:h-[415px] relative overflow-hidden">
          <svg
            width="711"
            height="1110"
            className="absolute w-[440px] h-[840px] top-[-300px] left-[-170px]"
            viewBox="0 0 711 1110"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g id="Oval" opacity="0.5" filter="url(#filter0_f_2_2055)">
              <ellipse
                cx="355.59"
                cy="554.561"
                rx="218.464"
                ry="418.89"
                transform="rotate(2.3687 355.59 554.561)"
                fill="url(#paint0_radial_2_2055)"
                fillOpacity="0.77"
              />
            </g>
            <defs>
              <filter
                id="filter0_f_2_2055"
                x="0.701874"
                y="0.0155945"
                width="709.777"
                height="1109.09"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="67.957"
                  result="effect1_foregroundBlur_2_2055"
                />
              </filter>
              <radialGradient
                id="paint0_radial_2_2055"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(355.59 554.561) rotate(87.2684) scale(419.367 153.246)">
                <stop stopColor="#AA22C5" />
                <stop offset="1" stopColor="#240253" />
              </radialGradient>
            </defs>
          </svg>
          <div className="container relative">
            <div className="text-center max-w-[670px] mx-auto">
              <h1 className="text-[20px] md:text-[40px] font-semibold text-white mb-3 md:mb-5">
                Website Merchant Terms and Conditions
              </h1>
            </div>
          </div>
        </section>
        <div className="col-md-12 text-justify !p-[8%] md:py-[96px] tnc_content container">
          <InitialTnc />
          <AttachmentA />
          <ScheduleA />
          <p style={{ display: "flex", justifyContent: "center" }}>
            <b>Annexure 1</b>
          </p>
          <p style={{ display: "flex", justifyContent: "center" }}>
            <b>
              List of the Negative, Risky and Restricted Categories of business
            </b>
          </p>
          <p style={{ display: "flex", justifyContent: "center" }}>
            <b>
              As already Provided under Attachment A to these Terms and
              Conditions
            </b>
          </p>
          <br />
          <ScheduleB />
          <ScheduleC />
          <ScheduleD />
          <ScheduleE />
          <ScheduleF />
          <ScheduleG />
          <ScheduleH />
          <ScheduleI />
          {/* <ScheduleJ /> */}
          <p>For Any Queries / Details Users Can Contact:</p>
          <p className="mt-[5px]">
            <b>Cashfree Payments India Pvt Ltd,</b>
          </p>
          <p>1st floor, Essae Vaishnavi Summit,</p>
          <p>7th main 80 Feet Road, Koramangala 3rd Block,</p>
          <p>Bangalore, Karnataka, India, 560034</p>
        </div>
        <GetStarted utmSourceAction="source-action=TnC" />
      </section>
    </Layout>
  );
};
export default tnc;
